/**
 * Portal-Rollen-Helfer (UX; echte Durchsetzung erfolgt im Backend).
 * Muss mit docs/RBAC.md und adminOrTeamleadMiddleware übereinstimmen.
 */

export type PortalRole = 'TECHNICIAN' | 'ADMIN' | 'TEAMLEAD';

export function getPortalRoleLabel(role: PortalRole | undefined): string {
  switch (role) {
    case 'ADMIN':
      return 'Admin';
    case 'TEAMLEAD':
      return 'Teamleiter';
    default:
      return 'Techniker';
  }
}

/** ADMIN oder TEAMLEAD: erweiterte Infrastruktur-Schreiboperationen (CW). */
export function canUseInfraPrivilegedOperations(role: PortalRole | undefined): boolean {
  return role === 'ADMIN' || role === 'TEAMLEAD';
}

/** Nur ADMIN: ConnectWise-Lager und -Lagerplätze im Portal anlegen. */
export function canManageInventoryStructure(role: PortalRole | undefined): boolean {
  return role === 'ADMIN';
}
